import { render, staticRenderFns } from "./DocSearch.vue?vue&type=template&id=5244d712&"
import script from "./DocSearch.vue?vue&type=script&lang=js&"
export * from "./DocSearch.vue?vue&type=script&lang=js&"
import style0 from "./DocSearch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports